<template>
  <div class="process-main-title">
    <div class="process-main-orderId" v-if="order">
      <h3>
        {{
          this.order.order_type === this.$constants.ORDER_TYPE.RIDE
            ? $t("SHARE_ORDER.HEADER.ORDER_ID_RIDE")
            : $t("SHARE_ORDER.HEADER.ORDER_ID")
        }}
      </h3>
      <h4>#{{ order.orderId }}</h4>
    </div>
    <p>
      {{ title }}
    </p>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "MainTitle",
  props: {
    order: Object,
    status: String,
  },
  computed: {
    title: {
      cache: false,
      get() {
        const formattedStatus = this.status
          ? this.status.replace(" ", "_")
          : null;

        return formattedStatus
          ? this.order.order_type === this.$constants.ORDER_TYPE.RIDE
            ? this.updateTitleRide
            : this.$t(`SHARE_ORDER.MAIN_TITLE.${formattedStatus}`)
          : "";
      },
    },
    updateTitleRide() {
      if (
        this.status === this.$constants.ORDER_STATUS.ACCEPTED &&
        this.order.sub_status === "ARRIVED"
      ) {
        return this.$t(`SHARE_ORDER.MAIN_TITLE_RIDE.BOARDED`);
      }
      const formattedStatus = this.status
        ? this.status.replace(" ", "_")
        : null;
      return this.$t(`SHARE_ORDER.MAIN_TITLE_RIDE.${formattedStatus}`);
    },
  },
};
</script>

<style lang="scss">
.process-main-title {
  display: flex;
  justify-content: space-between;

  .process-main-orderId {
    padding-right: 8px;
    border-right: 1px solid #ccd6dd;
    text-align: left;

    h3 {
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
      color: #7a8189;
    }

    h4 {
      font-size: 15px;
      font-weight: 600;
      white-space: nowrap;
    }
  }

  p {
    margin-left: 8px;
    font-size: 14px;
    font-weight: 500;
    flex: 1;
    align-items: center;
    display: flex;
    color: #f37336;
    justify-content: end;
    margin: 0 10px;
  }

  .sub-title {
    margin-top: 4px;
    margin: 4px 10px 0 10px;
    font-size: 12px;
    font-weight: 400;
    flex: 1;
    align-items: center;
    display: flex;
    color: #f37336;
    justify-content: end;
  }
}
</style>
